(function (scope) {
  'use strict';

  var Forms = function (elementsOrSelector, options) {
    if (typeof elementsOrSelector === 'string') {
      this.$elements = $(elementsOrSelector);
    } else if (elementsOrSelector !== undefined) {
      this.$elements = elementsOrSelector;
    }

    this.options = options;

    if (this.$elements.length) {
      this.initialize();
    } else {
      console.warn('Forms selector doesn\'t match any elements.');
    }
  };

  Forms.prototype.validateEmail = function (input) {
    var atIndex = input.indexOf('@');
    var dotIndex = input.lastIndexOf('.');
    return (atIndex < 1 || dotIndex < atIndex + 2 || dotIndex + 2 >= input.length);
  };

  Forms.prototype.validatePhoneNumber = function (input) {
    var phoneNumberTest = /(?!\+)(?!\s)\D/g;
    return (input.length < 6 || (input.match(phoneNumberTest) !== null));
  };

  Forms.prototype.isRegulationsAccepted = function (input) {
    return input && !input.checked;
  };

  Forms.prototype.initialize = function () {
    this._attemptsLeft = 100;

    var scope = this;
    this._bindInitValidation = this._initValidation.bind(this, function() {
      // _initValidation callback funkcija – papildinam nometņu select lauku
      /* scope._attemptsLeft = 100;
      if (scope.options && scope.options.replaceListOptions) {
        scope._bindAppendInfoToSelect = scope._appendInfoToSelect.bind(scope);
        scope._appendInfoToSelect();
      } */
    });
    this._bindInitValidation();
  };

  Forms.prototype._initValidation = function (callback) {
    var scope = this;

    var $fields = this.$elements.find('.field-email, .field-phone, .field-regulation-1, .field-regulation-2');
    if ($fields.length) {
      this._bindWaitForResponseMessage = this._waitForResponseMessage.bind(this);

      var $submit = this.$elements.find('input[type="button"]');
      $submit.on('click touchdown', this._bindWaitForResponseMessage);
      $submit.attr('disabled', true);

      $fields.on('input change', function (event) {
        var $target = $(event.target);
        var invalidEmail = true;
        var invalidPhone = true;
        var invalidRegulation1 = true;
        var invalidRegulation2 = true;

        invalidEmail = scope.validateEmail($fields[0].value);
        invalidPhone = scope.validatePhoneNumber($fields[1].value);
        invalidRegulation1 = scope.isRegulationsAccepted($fields[2]);
        invalidRegulation2 = scope.isRegulationsAccepted($fields[3]);

        var invalidInput = invalidEmail || invalidPhone || invalidRegulation1 || invalidRegulation2;
        $submit.attr('disabled', invalidInput);
      });

      if (callback) {
        callback();
      }
    } else {
      if (this._attemptsLeft > 0) {
        this._waitTimeout = window.setTimeout(this._bindInitValidation, 100);
        this._attemptsLeft -= 1;
      }
    }
  };

  Forms.prototype._waitForResponseMessage = function () {
    console.log('Waiting for form response message', 'Attempts left:', this._attemptsLeft);
    var $responseMessage = this.$elements.find('.nf-response-msg');
    if ($responseMessage.children().length) {
      console.log('Form response message found.');
      var $linksGroup = this.$elements.parent().find('.links-group');
      if ($linksGroup.length) {
        $linksGroup.hide();
      }
    } else {
      if (this._attemptsLeft > 0) {
        this._waitTimeout = window.setTimeout(this._bindWaitForResponseMessage, 100);
        this._attemptsLeft -= 1;
      }
    }
  };

  Forms.prototype._appendInfoToSelect = function (callback) {
    var $listselect = this.$elements.find('.listselect-container');
    if ($listselect.length) {
      var $rootContainer = $listselect.parent();
      var label = $listselect.find('.nf-field-label > label').text();

      var $newListSelect = $listselect.clone();
      var $options = $newListSelect.find('option');
      $options.each(function (index, element) {
        var $el = $(element);

        var availability = '';
        var value = parseInt($el.attr('value'), 10);
        if (typeof value !== 'undefined') {
          if (value === 0) {
            availability = 'vietu nav';
          } else if (value === 2) {
            availability = 'gandrīz pilns';
          } else if (value === 1) {
            availability = 'brīvas vietas';
          }
        }

        $el.text($el.text() + ' ' + availability);
      });

      $listselect.remove();
      $rootContainer.append($newListSelect);
      if (callback) {
        callback();
      }
    } else {
      if (this._attemptsLeft > 0) {
        this._waitTimeout = window.setTimeout(this._bindAppendInfoToSelect, 100);
        this._attemptsLeft -= 1;
      }
    }
  };

  scope.Forms = Forms;
})(window.Roots || (window.Roots = {}));
